import React from 'react'

export function convertStrongTags(text) {
  const splitText = text.replace(/(\r\n|\n|\r)/gm, ' ').split(/<strong>(.*?)<\/strong>/g)
  if (splitText.length <= 1) {
    return text
  }
  return splitText.map((element, index) => (index % 2 === 0 ? element : <strong>{element}</strong>))
}
